import { getProjectsAPI, saveProjectAPI, editProjectAPI, deleteProjectAPI } from '../api/projectManagementAPI'
import useProjectModelManagementStore from '../store/useProjectManagementStore';
import { useSwal } from '../../../../components/Notifications/swal/SwalCom';
import { getLoggedInOwnerId } from '../../../../utils/auth';

const useProjectManagementHook = () => {
    const { setProjects, updateProjects, setProjectName, setProjectDetailInputField, setProjectInfo,setIsModalOpen } = useProjectModelManagementStore();
    const { swalSuccess, swalFail } = useSwal();

    const resolveOwnerId = () => {
        const ownerId = getLoggedInOwnerId();
        if (!ownerId) {
            console.warn('Owner ID not found in storage.');
        }
        return ownerId;
    };

    const handleGetProjects = async (params) => {
        try {
            const ownerId = resolveOwnerId();
            if (!ownerId) return;
            params = { owner_id: ownerId, ...(params || {}) };
            // setIsLoading(true);
            const response = await getProjectsAPI(params)
            
            const reportData = response?.data || [];
            setProjects(reportData);
        } catch (error) {
            console.error('Error fetching summary report:', error);

        } finally {
            // setIsLoading(false);
        }

    }

    const handleDeleteProject = async (params) => {
        try {
            const ownerId = resolveOwnerId();
            if (!ownerId) return;
            const requestParams = { ...(params || {}), owner_id: ownerId };
            // setIsLoading(true);
            
            const response = await deleteProjectAPI({ params: requestParams })
            await handleGetProjects(null);
        } catch (error) {
            console.error('Error fetching summary report:', error);
        } finally {
            // setIsLoading(false);
        }
    }

    const handleEditProject = async (params) => {
        try {
            const ownerId = resolveOwnerId();
            if (!ownerId) return;
            if (params instanceof FormData && !params.get("owner_id")) {
                params.append("owner_id", ownerId);
            }
            // setIsLoading(true);
            const response = await editProjectAPI(params);
            const message = response?.data?.message;
            if (message == "success") {
                handleResetAddPopup();
                await handleGetProjects(null);
                swalSuccess("Success", "Project saved successfully.");
                 setIsModalOpen(false);
            }
            else {
                swalFail("Save failed", message || "Unknown error while saving the project.");
            }
        } catch (error) {
            console.error('Error fetching summary report:', error);
            swalFail("Save failed", "Something went wrong while saving the project.");

        } finally {
            // setIsLoading(false);
        }
    }

    const handleSaveProject = async (params) => {
        try {
            const ownerId = resolveOwnerId();
            if (!ownerId) return;
            if (params instanceof FormData && !params.get("owner_id")) {
                params.append("owner_id", ownerId);
            }
            const response = await saveProjectAPI(params);
            const message = response?.data?.message;
            if (message == "success") {
                handleResetAddPopup();
                await handleGetProjects(null);
                swalSuccess("Success", "Project saved successfully.");
                setIsModalOpen(false);
            }
            else {
                swalFail("Save failed", message || "Unknown error while creating the project.");
            }
        } catch (error) {
            console.error('Error fetching summary report:', error);
            swalFail("Save failed", "Something went wrong while creating the project.");

        } finally {
            // setIsLoading(false);
        }
    }

    const handleResetAddPopup = () => {
        setProjectName(null);
        setProjectDetailInputField(null);
        setProjectInfo(null)
    }

    const handler = {
        handleGetProjects: handleGetProjects,
        handleDeleteProject: handleDeleteProject,
        handleEditProject: handleEditProject,
        handleSaveProject: handleSaveProject,
        handleResetAddPopup: handleResetAddPopup


    }

    return { handler }
}
export default useProjectManagementHook;